import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'App.ManagePaymentBatchesHeader.ManagePaymentBatches',
    defaultMessage: 'Manage Payment Batches',
  },
  createPaymentBatch: {
    id: 'App.ManagePaymentBatchesHeader.CreatePaymentBatch',
    defaultMessage: 'Create Payment Batch',
  },
  filterBySubsidy: {
    id: 'App.ManagePaymentBatchesHeader.FilterBySubsidy',
    defaultMessage: 'Filter By Type',
  },
  filterByPeriod: {
    id: 'App.ManagePaymentBatchesHeader.FilterByPeriod',
    defaultMessage: 'Filter By Period',
  },
});

export default messages;
